import React, { useEffect, useRef } from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { useElementDimensions } from "@sportal/cdk/hooks";

import { ContactInfoFooter } from "./ContactInfoFooter";
import { setFooterHeight } from "../../../store/layout";
import { ConfigLink } from "../../configLink/ConfigLink";
import { useIntlTranslate } from "../../../hooks";

import "./Footer.scss";

export const FOOTER_CLASS_NAME = "footer";

function FooterComponent({
  footerCompanyLink,
  footerIcons,
  footerPhoneNumbers,
  footerSupportLink,
  setFooterHeight,
}) {
  const footerRef = useRef();
  const translate = useIntlTranslate();
  const { height } = useElementDimensions(footerRef);

  useEffect(() => {
    setFooterHeight(height);
  }, [setFooterHeight, height]);

  return (
    <footer className={FOOTER_CLASS_NAME} ref={footerRef}>
      {(footerSupportLink.url || !_.isEmpty(footerPhoneNumbers)) && (
        <ContactInfoFooter
          footerIcons={footerIcons}
          footerSupportLink={footerSupportLink}
          footerPhoneNumbers={footerPhoneNumbers}
        />
      )}

      <div className="common-footer">
        <div className="common-footer__content layout__container">
          <div className="common-footer__content-block">
            &copy;
            <FormattedMessage id="years" />
            &nbsp;
            <ConfigLink
              className="link"
              to={footerCompanyLink}
              aria-label={translate("company_name_link_aria_label", {
                companyName: translate("company_name"),
              })}
            >
              <FormattedMessage id={"company_name"} />
            </ConfigLink>
            . &nbsp;
          </div>
          <div className="common-footer__content-block">
            <FormattedMessage id="rights" />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default connect(
  ({
    config: {
      footerIcons,
      footerPhoneNumbers,
      footerSupportLink,
      footerCompanyLink,
    },
  }) => ({
    footerIcons,
    footerPhoneNumbers,
    footerSupportLink,
    footerCompanyLink,
  }),
  {
    setFooterHeight,
  }
)(FooterComponent);
